import { useTabActive } from '@wix/wix-chatbot-common/hooks';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { selectChatSessionState } from '../../common/selectors/chat';
import { selectIsCopilotChatbotVisible } from '../../common/selectors/meta';
import { renderModel } from '../../util/renderModel';
import { markAsRead } from '../api/messageApi';

const isCopilot = renderModel.isCopilot();

export const useMarkAsReadOnTabChange = () => {
  const isTabActive = useTabActive();
  const { conversationId, lastMessageId, unreadCount } = useSelector(selectChatSessionState);
  const isCopilotChatbotVisible = useSelector(selectIsCopilotChatbotVisible);

  useEffect(() => {
    if (isTabActive) {
      if (!conversationId || !lastMessageId || unreadCount === 0) {
        return;
      }
      if (isCopilot && !isCopilotChatbotVisible) {
        return;
      }
      markAsRead(conversationId, lastMessageId);
    }
  }, [isTabActive, isCopilotChatbotVisible]);
};
